import { Time } from '@angular/common';
import { Data } from '@angular/router';



export class TrialLicenseResponse  {
    TrialProducts: TrialProductArray;
    CurrentProductID: number;
    CurrentProductName: string;
    TrialID: number;
    InTrial: boolean = false;
    TrialProductID: number;
    TrialProductName: string;
    TrialStart: Date;
    TrialExpiration: Date;
}


export class TrialProduct{
  BaseProductID : number;
  BaseProductName : string;
  TrialProductID : number;
  TrialProductName :string;
  TrialTime : Time;
}

export class TrialProductArray extends Array<TrialProduct> {

    constructor(...items: TrialProduct[]) {
        super(...items);
        Object.setPrototypeOf(this, TrialProductArray.prototype);
    }

}